module.exports = ".checkbox{\r\n    margin-top :4%;\r\n}\r\n.mgr-1{\r\n    margin-left :1%;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/a2122-ytimeaxis/ytimeaxis.component.css
// module id = ./src/app/a2122-ytimeaxis/ytimeaxis.component.css
// module chunks = main